'use strict';

function DropdownDirective () {

  function link (scope, el, attrs, ctrl) {
    ctrl.init();
  }

  return {
    bindToController: true,
    controller: 'DropdownController',
    controllerAs: 'dropdownCtrl',
    link: link,
    scope: {
      group: '@',
      show: '=?'
    },
    templateUrl: 'saturn/dropdown/dropdown.tpl.html',
    transclude: true
  };
}

module.exports = DropdownDirective;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/dropdown/src/DropdownDirective.js